"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoJSONCreator = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'GEOJSON-CREATOR';
class GeoJSONCreator extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            try {
                const { latitude, longitude } = params;
                if (latitude && longitude) {
                    return {
                        // the geoJson is wrong by the types, but we can't realistically expand our types to include GeoJSON.
                        //eslint-disable-next-line
                        //@ts-ignore
                        geojson: {
                            type: 'Point',
                            coordinates: [longitude, latitude],
                        },
                    };
                }
                return null;
            }
            catch (e) { }
            return null;
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
}
exports.GeoJSONCreator = GeoJSONCreator;
GeoJSONCreator._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'GeoJSON Creator',
    isIdempotent: true,
    primaryCategory: 'Geography',
};
//# sourceMappingURL=GeoJSONCreator.js.map